import { Select } from 'antd';
import React, { useMemo } from 'react';
import tracker from '@src/utils/sensor/apptracker';
import { EVENT_METRIC_WIDGET_EVENT_CHANGE } from '@src/utils/sensor/track';

const SelectEvent = ({ eventList, onChange, eventName, isLoading }) => {
  const options = useMemo(() => {
    return eventList.map((name) => ({ value: name, label: name }));
  }, [eventList]);

  const handleChange = (value: string) => {
    onChange(value);
    tracker(EVENT_METRIC_WIDGET_EVENT_CHANGE, { eventName: value });
  };

  return (
    <Select
      value={eventName}
      style={{ width: 200 }}
      onChange={handleChange}
      options={options}
      loading={isLoading}
      showSearch
      filterOption={(input, option) =>
        String(option?.label ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      placeholder="Search and select event"
    />
  );
};

export default SelectEvent;
